import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_yfxmka3vaz: FaireBrandEntity = {
  token: "b_yfxmka3vaz",
  type: "brand",
  name: "Koala Meditation Mist",
  avatarUrl:
    "https://cdn.faire.com/fastly/b5d1867db7a8f596629906b6b6dab1287b8fe7303272bbd85a0ff24e763a3b45.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/fac98dd7211e8219342b907cf9477cf4ece1078417dafa1baf4538a1f02bf0d2.png",
  logoUrl:
    "https://cdn.faire.com/fastly/b5d1867db7a8f596629906b6b6dab1287b8fe7303272bbd85a0ff24e763a3b45.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/fac98dd7211e8219342b907cf9477cf4ece1078417dafa1baf4538a1f02bf0d2.png",
  location: "Las Vegas, NV, USA",
  minimumOrderDollars: 75,
  rating: 0,
  reviewCount: 0,
  isInsider: true,
  description:
    "After multiple collapsed lungs, our founder became a Massage Therapist for Cirque Du Soleil.  He studied at Harvard HMX and is a NASA SpaceApps Navigator. \n\nBreathing clean fresh humid air every breath is our mission. \n\nThe KOALA Meditation Mist was created. \n\nThe Daily routine for everyone who breaths must include the Koala Meditation Mist! \n\nSo we make sure you and your clients can care for their respiratory health and wellness in every meditative breath. \n\n ",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:46:44.130Z",
    importedBy: "entity-db-cli",
  },
};
